import { currencyListForLink } from "../../constants/currencyListForLink";
import { CurrencyItemType } from "../../store/slices/currencyListSlice";

export function getCurrencySymbolByCurrencyId(currencyList: CurrencyItemType[], currencyId:number) {
    if (currencyList.length === 0) {
        currencyList = currencyListForLink;
    }
    const index = currencyList.findIndex(w => w.currencyId == currencyId || w.currencyIsoCode == currencyId.toString());

    if (index != -1) {
        return currencyList[index].currencySymbol;
    }
    return "₺";
}